import * as React from 'react';
import { Form, Input, EditModes, LookUpDropDown, SystemPanel } from 'library';
import { IFormData, IFormState, SystemFormDetail } from 'library/form/SystemFormDetail';
import * as Base from 'library';
import { SystemGridAndForm } from 'library/form/SystemGridForm';
import Comments from 'Components/Opportunities/Comments'
import AddComments from 'Components/Opportunities/AddComments';
import Contracts from 'Components/Opportunities/Contracts'
import AddAnnuelContracts from 'Components/Opportunities/AddAnnuelContracts';
import EstimatedCost from 'Components/Opportunities/EstimatedCost'
import AddEstimatedCost from 'Components/Opportunities/AddEstimatedCost';
import ProjectScoreCard from 'Components/Opportunities/ProjectScoreCard';
import { SystemDashboardLayout } from 'library';
import HeaderDashboard from '../DashboardComponent/headerdashboard/HeaderDashboard';
import { withRouter } from 'react-router-dom';
import { HttpService } from 'library';
import { toast } from 'react-toastify';
import { hasReadPermission, hasEditPermission, hasAddPermission } from '../../service/userService';
import { getUserInfo } from 'service/userService'
interface IDataModel extends IFormData {
    PrimaryKeyEncrypted?: string,
    OpportunityId?: string,
    Name?: string,
    Description?: string,
    OpportunityType?: string,
    BDOffice?: string,
    PrimaryNAICS?: string,
    SolicitationNo?: string,
    PoP?: string,
    Agency?: string,
    Customer?: string,
    StrategicPartner?: string,
    TrailbossRole?: string,
    StrategicPartnerRole?: string,
    Incumbent?: string,
    WorkflowStatus?: string,
    OpportunityStatus?: string,
    EstimatedContractTotal?: string,
    EstimatedContractTB?: string,
    EstimatedProfitTotal?: string,
    EstimatedProfitTB?: string,
    EstimatedFullTimeEmployeesTotal?: string,
    EstimatedFullTimeEmployeesTB?: string,
    PriceToWin?: string,
    RFPReleaseDate?: string,
    ContractStartDate?: string,
    BidDecisionDate?: string,
    BNADecision?: string,
    ProposalDueDate?: string,
    DateProposalSubmittedDate?: string,
    RowVersion?: string
}

///**
//* @author:Sanju Bishnoi
//* @description: format currency for the amount.
//*/
//const formatter = new Intl.NumberFormat('en-US', {
//    style: 'currency',
//    currency: 'USD',
//    minimumFractionDigits: 2,
//});

export default class OpportunityForm extends SystemFormDetail<IDataModel> {
    data: any;
    canOpenOpportunity: boolean = false
    disableAddEdit: boolean = false
    OpportunityId: string = 'NEW ITEM'
    constructor(props: any) {
        super(props);
        this.data = props.location.data
    }

    componentDidMount = () => {

        let permission = hasAddPermission('Top.Opportunity') || hasEditPermission('Top.Opportunity');
        if (permission) {
            let isAdmin = getUserInfo().User.IsAdministrator;
            this.disableAddEdit = (this.data && this.data.WorkflowStatus == 'Close') && !isAdmin ? true : false;
        }
        else {
            this.disableAddEdit = true;
        }

        let openPermission = hasReadPermission('Top.OpenOpportunity');
        if (openPermission)
            this.canOpenOpportunity = this.data && this.data.PrimaryKeyEncrypted && this.data.WorkflowStatus == 'Close' ? true : false;
        else
            this.canOpenOpportunity = false;
    }

    initial = (): IFormState<IDataModel> => {
        return {
            formData: {
                PrimaryKeyEncrypted: (this.data && this.data.PrimaryKeyEncrypted) ? this.data.PrimaryKeyEncrypted : undefined,
                OpportunityStatus: 'Reported'
            },
        }
    }

    load = (data: IDataModel) => {
        if (data) {
            this.OpportunityId = data.OpportunityId
            this.setState({
                formData: {
                    ...data,
                    PrimaryKeyEncrypted: data.PrimaryKeyEncrypted,
                    OpportunityId: data.OpportunityId,
                    Name: data.Name,
                    Description: data.Description,
                    OpportunityType: data.OpportunityType,
                    BDOffice: data.BDOffice,
                    PrimaryNAICS: data.PrimaryNAICS,
                    SolicitationNo: data.SolicitationNo,
                    PoP: data.PoP,
                    Agency: data.Agency,
                    Customer: data.Customer,
                    StrategicPartner: data.StrategicPartner,
                    TrailbossRole: data.TrailbossRole,
                    StrategicPartnerRole: data.StrategicPartnerRole,
                    Incumbent: data.Incumbent,
                    WorkflowStatus: data.WorkflowStatus,
                    OpportunityStatus: data.OpportunityStatus,
                    EstimatedContractTotal: data.EstimatedContractTotal,
                    EstimatedContractTB: data.EstimatedContractTB,
                    EstimatedProfitTotal: data.EstimatedProfitTotal,
                    EstimatedProfitTB: data.EstimatedProfitTB,
                    EstimatedFullTimeEmployeesTotal: data.EstimatedFullTimeEmployeesTotal,
                    EstimatedFullTimeEmployeesTB: data.EstimatedFullTimeEmployeesTB,
                    PriceToWin: data.PriceToWin,
                    RFPReleaseDate: data.RFPReleaseDate,
                    ContractStartDate: data.ContractStartDate,
                    BidDecisionDate: data.BidDecisionDate,
                    BNADecision: data.BNADecision,
                    ProposalDueDate: data.ProposalDueDate,
                    DateProposalSubmittedDate: data.DateProposalSubmittedDate,
                    RowVersion: data.RowVersion,
                }
            })
        }
    }

    onOpenOpportunity = () => {
        let url = '/Opportunity/OpenOpportunity/' + this.state.formData.PrimaryKeyEncrypted
        var response = HttpService.get(url);
        var response = HttpService.get(url);
        response.then((data) => {
            if (data.data) {
                toast.info("Opportunity opened successfully.");
                this.canOpenOpportunity = false;
                this.disableAddEdit = false;
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        WorkflowStatus: "Opportunity ID & Assessment"
                    }
                }));
            }
        }).catch((error) => {
            toast.error("Failed to open opportunity. Please try again.");
        });
    }

    render() {
        return (<>
            <div className="DashboardWrapperChild">
                <div className="contentWrapper">
                    <HeaderDashboard title="Top" tagLine="" />
                    <div className="container-fluid mt-80">
                        <div className="row">
                            <div className="col-md-12">
                                <section className="tile-wrapper row">
                                    <div className="container-fluid containerpadding row security-tile-mobile">
                                        {this.canOpenOpportunity &&
                                            <div className="col-md-1 mb-2" style={{ right: '820px' }}>
                                                <button key={Math.random()} className="btn btnSave me-2" onClick={() => { this.onOpenOpportunity() }} >Open Opportunity</button>
                                            </div>
                                        }
                                        <fieldset className="fieldsetGridAndForm" disabled={this.disableAddEdit ? true : false}>
                                            <Form
                                                label="Opportunity"
                                                url={'Opportunity'}
                                                onLoad={this.load}
                                                showReview={false}
                                                primaryKeyEncrypted={this.state.formData.PrimaryKeyEncrypted}
                                                securityObject="Top.Opportunity"
                                                schema="Top" table="Opportunity"
                                                onInitialize={this.initialize}
                                                onClear={this.initialize}
                                                onValidate={this.validate}
                                                onPrepare={this.prepare}
                                                showBack={true}
                                                onRecordUpdated={this.onRecordUpdated}>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Input
                                                        isRequired={false}
                                                        id="id"
                                                        name="id"
                                                        label='Opportunity ID'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        validator={this.validator}
                                                        disabled={true}
                                                        labelFormat="nocase"
                                                        value={this.OpportunityId} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Input
                                                        isRequired={true}
                                                        id="name"
                                                        name="name"
                                                        label='Opportunity Name'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        validator={this.validator}
                                                        value={this.state.formData.Name} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Input
                                                        isRequired={true}
                                                        id="Description"
                                                        name="Description"
                                                        label='Description'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        validator={this.validator}
                                                        value={this.state.formData.Description} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <LookUpDropDown
                                                        id="OpportunityType"
                                                        name="OpportunityType"
                                                        label='Opportunity Type'
                                                        lookupName="/Opportunity/LookupValue/OpportunityType"
                                                        isRequired={true}
                                                        onChange={this.handleChange}
                                                        validator={this.validator}
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        value={this.state.formData.OpportunityType} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <LookUpDropDown
                                                        id="BDOffice"
                                                        name="BDOffice"
                                                        label='BD Office'
                                                        lookupName="/Opportunity/LookupValue/BDOffice"
                                                        isRequired={true}
                                                        labelClass="col-12"
                                                        labelFormat="nocase"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        validator={this.validator}
                                                        value={this.state.formData.BDOffice} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <LookUpDropDown
                                                        id="PrimaryNAICS"
                                                        name="PrimaryNAICS"
                                                        label='Primary NAICS'
                                                        labelFormat="nocase"
                                                        isRequired={true}
                                                        lookupName="/Opportunity/LookupValue/NAICS"
                                                        displayField="DataText"
                                                        idField="DataValue"
                                                        onChange={this.handleChange}
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        validator={this.validator}
                                                        value={this.state.formData.PrimaryNAICS} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Input
                                                        isRequired={true}
                                                        id="solicitationNo"
                                                        name="solicitationNo"
                                                        label='Solicitation No'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.SolicitationNo}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Input
                                                        isRequired={true}
                                                        id="PoP" name="PoP"
                                                        label='PoP'
                                                        labelFormat="nocase"
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.PoP}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <LookUpDropDown
                                                        id="Agency"
                                                        name="Agency"
                                                        label='Agency'
                                                        lookupName='/Opportunity/LookupValue/Agency'
                                                        isRequired={true}
                                                        onChange={this.handleChange}
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        validator={this.validator}
                                                        value={this.state.formData.Agency} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Input
                                                        isRequired={true}
                                                        id="customer" name="customer"
                                                        label='Customer'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.Customer}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Input
                                                        isRequired={true}
                                                        id="strategicPartner"
                                                        name="strategicPartner"
                                                        label='Strategic Partner'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.StrategicPartner}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <LookUpDropDown
                                                        id="trailbossRole"
                                                        name="trailbossRole"
                                                        label='Trailboss Role'
                                                        lookupName='/Opportunity/LookupValue/TrailbossRole'
                                                        isRequired={true}
                                                        onChange={this.handleChange}
                                                        validator={this.validator}
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        value={this.state.formData.TrailbossRole} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <LookUpDropDown
                                                        id="strategicPartnerRole"
                                                        name="strategicPartnerRole"
                                                        label='Strategic Partner Role'
                                                        lookupName='/Opportunity/LookupValue/StrategicPartnerRole'
                                                        isRequired={true}
                                                        onChange={this.handleChange}
                                                        validator={this.validator}
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        value={this.state.formData.StrategicPartnerRole} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Input
                                                        isRequired={true}
                                                        id="incumbent"
                                                        name="incumbent"
                                                        label='Incumbent'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.Incumbent}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <LookUpDropDown
                                                        id="workflowStatus"
                                                        name="workflowStatus"
                                                        label='Workflow Status'
                                                        lookupName='/Opportunity/LookupValue/WorkflowStatus'
                                                        isRequired={true}
                                                        onChange={this.handleChange}
                                                        validator={this.validator}
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        value={this.state.formData.WorkflowStatus} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <LookUpDropDown
                                                        id="opportunityStatus"
                                                        name="opportunityStatus"
                                                        label='Opportunity Status'
                                                        lookupName='/Opportunity/LookupValue/OpportunityStatus'
                                                        isRequired={true}
                                                        onChange={this.handleChange}
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        validator={this.validator}
                                                        value={this.state.formData.OpportunityStatus} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2 currency-input">
                                                    <Input
                                                        isRequired={false}
                                                        id="priceToWin"
                                                        type="number"
                                                        name="priceToWin"
                                                        label='Price to Win'
                                                        labelFormat="nocase"
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.PriceToWin}
                                                        validator={this.validator} />
                                                    <span style={{ padding: '3px' }} className="currency-icon">$</span>
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <LookUpDropDown
                                                        id="BNADecision"
                                                        name="BNADecision"
                                                        label='BNA Decision'
                                                        labelFormat="nocase"
                                                        lookupName='/Opportunity/LookupValue/BNADecision'
                                                        isRequired={true}
                                                        onChange={this.handleChange}
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        validator={this.validator}
                                                        value={this.state.formData.BNADecision} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <div className="form-group row">
                                                        <label className="col-md-12 col-12 col-form-label labelStart labelFontSize">Estimated Contract Value :</label>
                                                        <div className="col-md-6 currency-input">
                                                            <Input
                                                                isRequired={true}
                                                                type="number"
                                                                id="estimatedContractTotal"
                                                                name="estimatedContractTotal"
                                                                label='Estimated Contract Total'
                                                                labelClass="col-12"
                                                                minValue="0"
                                                                componentClass="col-12"
                                                                onChange={this.handleChange}
                                                                value={this.state.formData.EstimatedContractTotal}
                                                                validator={this.validator} />
                                                            <span style={{ padding: '3px' }} className="currency-icon">$</span>
                                                        </div>

                                                        <div className="col-md-6 currency-input">
                                                            <Input
                                                                isRequired={false}
                                                                type="number"
                                                                id="estimatedContractTB"
                                                                name="estimatedContractTB"
                                                                label='Estimated Contract - TB'
                                                                labelClass="col-12"
                                                                componentClass="col-12"
                                                                minValue="0"
                                                                labelFormat="nocase"
                                                                onChange={this.handleChange}
                                                                value={this.state.formData.EstimatedContractTB}
                                                                validator={this.validator} />
                                                            <span style={{ padding: '3px' }} className="currency-icon">$</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <div className="form-group row">
                                                        <label className="col-md-12 col-12 col-form-label labelStart labelFontSize">Estimated Profit Value :</label>
                                                        <div className="col-md-6 col-12 currency-input">
                                                            <Input
                                                                isRequired={true}
                                                                id="estimatedProfitTotal"
                                                                type="number"
                                                                name="estimatedProfitTotal"
                                                                label='Estimated Profit Total'
                                                                minValue="0"
                                                                labelClass="col-12"
                                                                componentClass="col-12"
                                                                onChange={this.handleChange}
                                                                value={this.state.formData.EstimatedProfitTotal}
                                                                validator={this.validator} />
                                                            <span style={{ padding: '3px' }} className="currency-icon">$</span>
                                                        </div>

                                                        <div className="col-md-6 col-12 currency-input">
                                                            <Input
                                                                isRequired={false}
                                                                id="estimatedProfitTB"
                                                                type="number"
                                                                name="estimatedProfitTB"
                                                                minValue="0"
                                                                label='Estimated Profit - TB'
                                                                labelFormat="nocase"
                                                                labelClass="col-12"
                                                                componentClass="col-12"
                                                                onChange={this.handleChange}
                                                                value={this.state.formData.EstimatedProfitTB}
                                                                validator={this.validator} />
                                                            <span style={{ padding: '3px' }} className="currency-icon">$</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <div className="form-group row">
                                                        <label className="col-md-12 col-12 col-form-label labelStart labelFontSize">Estimated Full Time Employees :</label>
                                                        <div className="col-md-6 col-12">
                                                            <Input
                                                                isRequired={false}
                                                                type="number"
                                                                id="estimatedFullTimeEmployeesTotal"
                                                                name="estimatedFullTimeEmployeesTotal"
                                                                label='Estimated Full Time Employees Total'
                                                                labelClass="col-12"
                                                                minValue="0"
                                                                componentClass="col-12"
                                                                onChange={this.handleChange}
                                                                value={this.state.formData.EstimatedFullTimeEmployeesTotal}
                                                                validator={this.validator} />
                                                        </div>

                                                        <div className="col-md-6 col-12">
                                                            <Input
                                                                isRequired={true}
                                                                type="number"
                                                                id="estimatedFullTimeEmployeesTB"
                                                                name="estimatedFullTimeEmployeesTB"
                                                                label='Estimated Full Time Employees - TB'
                                                                labelFormat="nocase"
                                                                labelClass="col-12"
                                                                minValue="0"
                                                                componentClass="col-12"
                                                                onChange={this.handleChange}
                                                                value={this.state.formData.EstimatedFullTimeEmployeesTB}
                                                                validator={this.validator} />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Base.DatePicker
                                                        isRequired={false}
                                                        id="RFPReleaseDate"
                                                        name="RFPReleaseDate"
                                                        label='RFP Release Date'
                                                        labelFormat="nocase"
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.RFPReleaseDate}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Base.DatePicker
                                                        isRequired={true}
                                                        id="contractStartDate"
                                                        name="contractStartDate"
                                                        label='Contract Start Date'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.ContractStartDate}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Base.DatePicker
                                                        isRequired={false}
                                                        id="bidDecisionDate"
                                                        name="bidDecisionDate"
                                                        label='Bid Decision Date'
                                                        labelFormat="nocase"
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.BidDecisionDate}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Base.DatePicker
                                                        isRequired={false}
                                                        id="proposalDueDate"
                                                        name="proposalDueDate"
                                                        label='Proposal Due Date'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.ProposalDueDate}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Base.DatePicker
                                                        isRequired={true}
                                                        id="dateProposalSubmittedDate"
                                                        name="dateProposalSubmittedDate"
                                                        label='Date Proposal Submitted'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.DateProposalSubmittedDate}
                                                        validator={this.validator} />
                                                </div>
                                            </Form>

                                            {(this.data === undefined) ?
                                                null
                                                :
                                                <>
                                                    <SystemGridAndForm label="Comments" form={AddComments} grid={Comments} data={this.state.formData.OpportunityId} securityObject="Top.Comments" />
                                                    <SystemGridAndForm label="Annual Contract" form={AddAnnuelContracts} grid={Contracts} data={this.state.formData.OpportunityId} securityObject="Top.AnnualContract" />
                                                    <SystemGridAndForm label="Estimated Cost" form={AddEstimatedCost} grid={EstimatedCost} data={this.state.formData.OpportunityId} securityObject="Top.EstimatedCosts" />
                                                    <SystemGridAndForm label="" grid={ProjectScoreCard} data={{ OpportunityId: this.state.formData.OpportunityId }} />
                                                </>}
                                        </fieldset>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }
};